import {
  GET_SERVICE_CATEGORIES,
  GET_SERVICE_CATEGORIES_LOADING,
} from "../actions/types";

// `map` stays null until the first successful read. Consumers treat null as
// "no opinion yet" and show everything, so a slow or failed call never blanks
// out the menu mid-session.
const initialState = {
  map: null,
  loading: false,
  loaded: false,
};

const serviceCategoriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SERVICE_CATEGORIES_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case GET_SERVICE_CATEGORIES:
      return {
        ...state,
        map: action.payload,
        loading: false,
        loaded: true,
      };
    default:
      return state;
  }
};

export default serviceCategoriesReducer;
